import { DASHBOARD_GRID_GAP } from "@/lib/dashboardToolbarUi";

/** Narrowest card width on phones — mirrors the lesson card mobile width. */
export const COURSE_GRID_MOBILE_CARD_WIDTH = 160;

export type CourseGridLayout = {
  cardWidth: number;
  numColumns: number;
  justify: "flex-start" | "center";
  isNarrow: boolean;
};

/**
 * Column count + stretched card width for catalog-card grids (courses hub,
 * instructor pages, purchased-courses "See all"). `inner` is the usable row
 * width: min(CONTENT_MAX_WIDTH, window) minus horizontal padding.
 */
export function courseGridLayout(inner: number): CourseGridLayout {
  const g = DASHBOARD_GRID_GAP;
  const widthPerCard = (count: number) =>
    Math.floor((inner - g * (count - 1)) / count);

  if (inner >= 1000) {
    return { numColumns: 4, cardWidth: widthPerCard(4), justify: "flex-start", isNarrow: false };
  }
  if (inner >= 720) {
    return { numColumns: 3, cardWidth: widthPerCard(3), justify: "flex-start", isNarrow: false };
  }
  if (inner >= COURSE_GRID_MOBILE_CARD_WIDTH * 2 + g) {
    return { numColumns: 2, cardWidth: widthPerCard(2), justify: "center", isNarrow: true };
  }
  return {
    numColumns: 1,
    cardWidth: Math.min(COURSE_GRID_MOBILE_CARD_WIDTH, inner),
    justify: "center",
    isNarrow: true,
  };
}
